import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

const Spinner = ({small = false, ...props}) => {
    return (
        <Grid container justifyContent="center" my={small ? 2 : 6}>
            <CircularProgress size={small ? 20 : 40} sx={{...props}} />
        </Grid>
    );
};

export default Spinner;
